import { render, staticRenderFns } from "./UserPasswordCard.vue?vue&type=template&id=416c0597"
import script from "./UserPasswordCard.vue?vue&type=script&lang=js"
export * from "./UserPasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports